const product = {
  information: "Informazione", // translated
  additionalInformation: "Informazioni aggiuntive", // translated
  contactUs: "Contattaci", // translated
  contactUsText: "Vuoi personalizzare il tuo tour o hai altre domande?", // translated
  dropUsAnEmail: "Mandaci un'e-mail", // translated
  viewLess: "Visualizza meno", // translated
  viewMore: "Visualizza di più", // translated
  less: "meno", // translated
  more: "di più", // translated
  highlights: "Mette in risalto", // translated
  inclusions: "Inclusioni", // translated
  exclusions: "Esclusioni", // translated
  pleaseWait: "Attendere prego...", // translated
  tourType: "Tipo di tour", // translated
  search: "Ricerca", // translated
  available: "Disponibile", // translated
  availableTours: "Tour disponibili", // translated
  sortBy: "ORDINA PER", // translated
  priceLowToHigh: "Prezzo: da basso ad alto", // translated
  priceHighToLow: "Prezzo: da alto a basso", // translated
  mostPopular: "Più popolare", // translated
  roomOnly: "Solo la stanza", // translated
  bedAndBreakfast: "Bed & Breakfast", // translated
  halfBoard: "Mezza pensione", // translated
  fullBoard: "Pensione completa", // translated
  allInclusive: "Tutto incluso", // translated
  viewDetails: "Visualizza dettagli", // translated
  close: "Chiudere", // translated
  at: "In", // translated
  person: "persona", // translated
  cancellationPolicy: "Politica di cancellazione", // translated
  cancellationIs: "la cancellazione è", // translated
  to: "UN", // translated
  bookingRemarks: "Osservazioni sulla prenotazione", // translated
  totalPrice: "Prezzo totale", // translated
  back: "Di ritorno", // translated
  bookNow: "Prenota ora", // translated
  minutes: "Minuti", // translated
  visitDuration: "Durata della visita", // translated
  itinerary: "Itinerario", // translated
  airportToHotel: "Dall'aeroporto all'hotel", // translated
  hotelToAirport: "Hotel all'aeroporto", // translated
  details: "dettagli", // translated
  servicesDetails: "Dettagli sui servizi", // translated
  services: "Servizi", // translated
  day: "Giorno", // translated
  next: "Prossimo", // translated
  nextStep: "Passo successivo", // translated
  skip: "Saltare", // translated
  remarks: "Osservazioni", // translated
  optional: "opzionale", // translated
  guests: "Ospiti", // translated
  payment: "Pagamento", // translated
  pickup: "Raccogliere", // translated
  featuredPackage: "Pacchetto in primo piano", // translated
  flights: "voli", // translated
  accommodation: "Struttura ricettiva", // translated
  transfers: "Trasferimenti", // translated
  tours: "Tour", // translated
  experiences: "Esperienze", // translated
  featuredTour: "Tour in primo piano", // translated
  From: "A partire dal", // translated
  Accommodation: "Struttura ricettiva", // translated
  approxDuration: "ca. durata", // translated
  travellerInformation: "Informazioni sui viaggiatori", // translated
  bookingOverview: "Panoramica della prenotazione", // translated
  checkout: "Guardare", // translated
  paymentFailed: "Pagamento fallito", // translated
  paymentSuccess: "Pagamento riuscito", // translated
  night: "Notte", // translated
  viewEscapes: "Visualizza Fuga", // translated
  escapeType: "Tipo di fuga", // translated
  adultsOnly: "Solo adulti", // translated
  totalDuration: "Durata totale", // translated
  departingAirport: "Aeroporto in partenza", // translated
  products: "Prodotti", // translated
  viewExperience: "Visualizza l'esperienza", // translated
  product: "Prodotto", // translated
  options: "Opzioni", // translated
  nights: "Notti", // translated
  childrenAreNotAllowedInThisTour: "I bambini non sono ammessi in questo tour", // translated
};

export default product;
